import axios from 'axios'

import {
  INITIALIZE_STATE,
  SET_AUTHENTICATED,
  SET_AUTHENTICATED_USER,
  SET_SELECTED_COMPANY,
  SET_SELECTED_ORDER_OF_SERVICE,
  SET_SELECTED_CONTROL_PANEL,
  SET_SELECTED_STANDARD,
} from './mutation-types'

export default {
  async login({ dispatch }, user) {
    return new Promise((resolve, reject) => {
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          var credentials = {
            email: user.value.email,
            password: user.value.password,
          }

          axios
            .post('/api/login', credentials)
            .then((response) => {
              if (response?.success) {
                dispatch('setAuthenticatedUser')
              }

              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  async logout({ dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/logout')
        .then((response) => {
          dispatch('setAuthenticatedUser')

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  async selectCompany({ commit }, company_id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/companies/get/' + company_id)
        .then((response) => {
          commit(SET_SELECTED_COMPANY, response.data.data)

          resolve(response)
        })
        .catch((error) => {
          commit(SET_SELECTED_COMPANY, null)

          reject(error)
        })
    })
  },

  async selectOrderOfService({ commit }, order_of_service_id) {
    return new Promise((resolve, reject) => {
      if (order_of_service_id) {
        axios
          .get('/api/orders_of_service/get/' + order_of_service_id)
          .then((response) => {
            commit(SET_SELECTED_ORDER_OF_SERVICE, response.data.data)

            resolve(response)
          })
          .catch((error) => {
            commit(SET_SELECTED_ORDER_OF_SERVICE, null)

            reject(error)
          })
      } else {
        commit(SET_SELECTED_ORDER_OF_SERVICE, null)
        resolve({})
      }
    })
  },

  async selectControlPanel({ commit }, control_panel) {
    return new Promise((resolve) => {
      commit(SET_SELECTED_CONTROL_PANEL, control_panel)
      resolve()
    })
  },

  async selectStandard({ commit }, standard_id) {
    return new Promise((resolve, reject) => {
      if (standard_id) {
        axios
          .get('/api/standards/get/' + standard_id)
          .then((response) => {
            commit(SET_SELECTED_STANDARD, response.data.data)

            resolve(response)
          })
          .catch((error) => {
            commit(SET_SELECTED_STANDARD, null)

            reject(error)
          })
      } else {
        commit(SET_SELECTED_STANDARD, null)
        resolve({})
      }
    })
  },

  async setAuthenticatedUser({ commit }) {
    return new Promise((resolve, reject) => {
      commit(INITIALIZE_STATE)

      axios
        .get('/api/authenticated_user')
        .then((response) => {
          commit(SET_AUTHENTICATED, response.data.user != null)
          commit(SET_AUTHENTICATED_USER, response.data.user)

          resolve(response)
        })
        .catch((error) => {
          commit(SET_AUTHENTICATED, false)
          commit(SET_AUTHENTICATED_USER, null)

          reject(error)
        })
    })
  },
}
